import React, { useEffect, useState, useRef } from "react";
import useClickOutside from "../../hook/UseClickOutSide";
import { OptionsRegionsType } from "./SelectRegions";
import Provices from "../../Provinces.json";
import { Checkbox } from "@mantine/core";
import { OptionsType } from "./SelectItems";

export interface OptionsProvinceType {
  ProvinceCode: string;
  ProvinceName: string;
  RegionCode: string;
  Group17Provinces: number;
}

interface PropsType {
  onSelect: (value: OptionsProvinceType[]) => void;
  regions?: OptionsRegionsType;
  provinceGroup?: OptionsType;
  disable?: boolean;
  hasAll?: boolean;
  selectProvince?: OptionsProvinceType[];
}
function SelectProvice({
  onSelect,
  regions,
  hasAll,
  disable = false,
  selectProvince,
  provinceGroup,
}: PropsType) {
  const [isOpen, setIsOpen] = useState(false);
  const [option, setOption] = useState<OptionsProvinceType[]>([]);
  const [selectedValue, setSelectedValue] = useState<OptionsProvinceType[]>([]);
  const dropdownRef = useRef(null);

  const handleClickOpenItems = (value: boolean) => {
    if (!disable) setIsOpen(value);
  };

  const handleClickItems = (items: OptionsProvinceType) => {
    if (items.ProvinceCode !== "0") {
      let findItem = selectedValue.find(
        (item) => item.ProvinceCode === items.ProvinceCode
      );
      if (!findItem || findItem === undefined) {
        let provinces = selectedValue.filter(
          (province) => province.ProvinceCode !== "0"
        );
        setSelectedValue([...provinces, items]);
        onSelect([...provinces, items]);
      } else {
        let provinces = selectedValue.filter(
          (province) =>
            province.ProvinceCode !== "0" &&
            province.ProvinceCode !== items.ProvinceCode
        );
        if (provinces.length > 0) {
          setSelectedValue([...provinces]);
          onSelect([...provinces]);
        } else {
          setSelectedValue([option[0]]);
          onSelect([option[0]]);
        }
      }
    } else {
      setSelectedValue([items]);
      onSelect([items]);
    }
  };

  useClickOutside(dropdownRef, () => {
    setIsOpen(false);
  });

  useEffect(() => {
    if (selectProvince && selectProvince?.length > 0) {
      setSelectedValue(selectProvince);
    } else {
      if (hasAll) {
        let rawOption = option.filter((e) => e.ProvinceCode === "0");
        setSelectedValue([rawOption[0]]);
        onSelect([rawOption[0]]);
      } else {
        setSelectedValue([option[0]]);
        onSelect([option[0]]);
      }
    }
  }, [option]);

  useEffect(() => {
    let sortedProvice = Provices.slice().sort((a, b) =>
      a.ProvinceName.localeCompare(b.ProvinceName, "th-TH")
    );
    if (provinceGroup?.id === 1) {
      if (regions && regions.RegionCode !== "0") {
        sortedProvice = sortedProvice.filter(
          (e) => e.RegionCode === regions.RegionCode
        );
      }
      if (hasAll) {
        sortedProvice = [
          {
            ProvinceCode: "0",
            ProvinceName: "ทั้งหมด",
            RegionCode: "0",
            Group17Provinces: 0,
          },
          ...sortedProvice,
        ];
      }
    } else if (provinceGroup?.id === 2) {
      sortedProvice = sortedProvice.filter((e) => e.Group17Provinces === 1);
      if (hasAll) {
        sortedProvice = [
          {
            ProvinceCode: "0",
            ProvinceName: "ทั้งหมด",
            RegionCode: "0",
            Group17Provinces: 0,
          },
          ...sortedProvice,
        ];
      }
    }

    setOption(sortedProvice);
  }, [regions, provinceGroup]);

  return (
    <div className="relative" ref={dropdownRef}>
      <div
        className={`flex self-stretch pl-4 pr-2 h-10 bg-primary-contrast items-center rounded-xl border-[1px] ${
          disable ? "border-gray-1" : "border-gray-2"
        }`}
        onClick={() => handleClickOpenItems(!isOpen)}
      >
        {selectedValue.length === 1 && (
          <p
            className={`w-full text-sm ${
              disable ? "text-text-disabled" : "text-text-primary"
            } font-light`}
          >
            {selectedValue[0]?.ProvinceName}
          </p>
        )}
        {selectedValue.length > 1 && (
          <p
            className={`w-full text-sm line-clamp-1  ${
              disable ? "text-text-disabled" : "text-text-primary"
            } font-light`}
          >
            {selectedValue.map((province: OptionsProvinceType) => (
              <span
                key={province?.ProvinceCode}
              >{` ${province.ProvinceName}`}</span>
            ))}
          </p>
        )}
        <div className={`${isOpen && "-rotate-180"}`}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_904_68250)">
              <path
                d="M6.70978 9.30996C7.09978 8.91996 7.72978 8.91996 8.11978 9.30996L11.9998 13.19L15.8798 9.30996C16.2698 8.91996 16.8998 8.91996 17.2898 9.30996C17.6798 9.69996 17.6798 10.33 17.2898 10.72L12.6998 15.31C12.3098 15.7 11.6798 15.7 11.2898 15.31L6.69978 10.72C6.31978 10.34 6.31978 9.69996 6.70978 9.30996Z"
                fill={`${disable ? "#F6F6F6" : "#8E8E8E"}`}
              />
            </g>
            <defs>
              <clipPath id="clip0_904_68250">
                <rect
                  width="24"
                  height="24"
                  fill="white"
                  transform="matrix(0 1 1 0 0 0)"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>
      {isOpen && (
        <div className="w-full max-h-[300px] overflow-y-auto z-10 absolute bg-primary-contrast p-2 border-[1px] mt-1 border-gray-2 rounded-2xl">
          {option.map((e: any, index: number) => (
            <div
              className="flex items-center gap-2 w-full py-1 pl-4 pr-2 cursor-pointer hover:bg-primary-light rounded-xl"
              key={index}
              onClick={() => handleClickItems(e)}
            >
              {index !== 0 && (
                <Checkbox
                  onChange={(e: any) => {
                    e.preventDefault();
                  }}
                  checked={
                    selectedValue.find(
                      (item) => item.ProvinceCode === e.ProvinceCode
                    )
                      ? true
                      : false
                  }
                  className="province-checkbox"
                  size={"xs"}
                />
              )}
              <p className="text-sm text-text-primary font-light">
                {e.ProvinceName}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
export default SelectProvice;
